export const routes = {
    STREAMS: '/streams',
    STREAM_DETAILS: '/streams/:streamId',
    MONITORS: '/monitors',
    MONITOR_DETAILS: '/monitors/:monitorId',
    ERROR: '/error',
} as const;
